const ua = navigator.userAgent;

// 和 UA 相关的属性
export const isWebkit = () => {
    const reg = /webkit/i;
    return reg.test(ua);
};

export const isFox = () => {
    const reg = /Firefox/i;
    return reg.test(ua);
};

export const isFireFox = isFox;

export const isIE = () => {
    return 'ActiveXObject' in window;
};

export const isAndorid = () => {
    return ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
};

export default {
    // 是否 webkit
    isWebkit,

    isFireFox,
    isFox,

    // 是否 IE
    isIE,

    isAndorid
};
